export default __webpack_public_path__ + "img/e9fd34bb83f39ce31882abdebe88106b.svg";